import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import classnames from "classnames";
import { getPaginationArray } from "segments/desktop/careers/layouts/positions-careers/utils";
import { StyledPaginationComponent } from "segments/desktop/careers/layouts/positions-careers/pagination/pagination-component.scss";
import { PrevArrowIcon } from "segments/desktop/careers/layouts/positions-careers/pagination/prev-arrow-icon";
import { NextArrowIcon } from "segments/desktop/careers/layouts/positions-careers/pagination/next-arrow-icon";
const COLLAPSED_TABLE_RESULTS_LIMIT = 7;
const PaginationComponent = ({ numberOfPositions, numOfPages, currentPageNum, setPageNumber })=>{
    const paginationArray = useMemo(()=>getPaginationArray(currentPageNum, numOfPages), [
        currentPageNum,
        numOfPages
    ]);
    return /*#__PURE__*/ _jsx(StyledPaginationComponent, {
        className: "pagination-container",
        children: numberOfPositions > COLLAPSED_TABLE_RESULTS_LIMIT && numOfPages > 1 && /*#__PURE__*/ _jsx("div", {
            className: "pagination is-centered",
            role: "navigation",
            "aria-label": "pagination",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "pagination-list",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: classnames("pagination-link-container", "prev"),
                        children: /*#__PURE__*/ _jsx("a", {
                            className: classnames("pagination-link", "link-prev", {
                                "is-disabled": currentPageNum === 1
                            }),
                            title: "Previous",
                            onClick: ()=>currentPageNum > 1 && setPageNumber(currentPageNum - 1),
                            children: /*#__PURE__*/ _jsx(PrevArrowIcon, {
                                disabled: currentPageNum === 1
                            })
                        })
                    }),
                    paginationArray === null || paginationArray === void 0 ? void 0 : paginationArray.map((pageNum, index)=>/*#__PURE__*/ _jsx("li", {
                            className: classnames("pagination-link-container", {
                                "is-current": currentPageNum === pageNum
                            }),
                            children: pageNum === "..." ? /*#__PURE__*/ _jsx("span", {
                                className: "pagination-ellipsis",
                                children: "…"
                            }) : /*#__PURE__*/ _jsx("a", {
                                onClick: ()=>setPageNumber(pageNum),
                                className: "pagination-link",
                                "aria-label": `Page ${pageNum}`,
                                children: pageNum
                            })
                        }, index)),
                    /*#__PURE__*/ _jsx("li", {
                        className: "pagination-link-container",
                        children: /*#__PURE__*/ _jsx("a", {
                            className: classnames("pagination-link", {
                                "is-disabled": currentPageNum === numOfPages
                            }),
                            title: "Next",
                            onClick: ()=>currentPageNum !== numOfPages && setPageNumber(currentPageNum + 1),
                            children: /*#__PURE__*/ _jsx(NextArrowIcon, {
                                disabled: currentPageNum === numOfPages
                            })
                        })
                    })
                ]
            })
        })
    });
};
export default PaginationComponent;
